<div>
    <img style="height: 80px; cursor: pointer" [src]="croppedImage"  (click) = "clearTmpImg()"/>
    <button type="button" class="btn btn-info" style="margin-left: 11px;" (click)="openModal()">點我上傳</button>
</div>